package com.dotdrives.web.pages.onboarding

import com.dotdrives.controller.OnboardingUiState
import com.dotdrives.design.DotButtonVariant
import com.dotdrives.web.ui.DotButton
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h1
import react.dom.html.ReactHTML.p
import web.cssom.ClassName

external interface GiversStepProps : Props {
    var state: OnboardingUiState
    var onBack: () -> Unit
    var onImport: () -> Unit
    var onSkip: () -> Unit
}

val GiversStep = FC<GiversStepProps> { props ->
    div {
        className = ClassName("onboarding-step-form")

        div {
            className = ClassName("onboarding-step-meta dot-meta")
            +"STEP 4 OF 4"
        }
        h1 {
            className = ClassName("onboarding-step-title dot-heading")
            +"Add your first givers"
        }
        p {
            className = ClassName("onboarding-step-copy")
            +"Start with the people who already believe in you."
        }

        div {
            className = ClassName("onboarding-csv-disabled")
            div {
                className = ClassName("onboarding-csv-icon")
                ariaHidden = true
                +"📄"
            }
            div {
                className = ClassName("onboarding-csv-title")
                +"Drop your CSV here"
            }
            div {
                className = ClassName("onboarding-csv-copy")
                +"Bring your giver directory over now, then review every row before importing."
            }
            DotButton {
                text = "Import CSV"
                onClick = props.onImport
                className = "onboarding-finished-action"
            }
        }

        div {
            className = ClassName("onboarding-actions onboarding-actions-three")
            DotButton {
                text = "← Back"
                onClick = props.onBack
                variant = DotButtonVariant.Secondary
            }
            DotButton {
                text = "Skip — I'll add by hand"
                onClick = props.onSkip
                loading = props.state.loading
                className = "onboarding-action-primary"
            }
        }
    }
}
